<script lang="ts">
	//helpers
	import { format } from 'svelte-i18n';
	import { real_id } from 'src/helpers/interface_helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	// Design system components
	import { Collapse } from '@Shelly/shelly-design-system/index';
	// stores
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	// types
	import type { Device } from 'src/types/Device';
	// components
	import PillPeripheralMode from './PillPeripheralMode.svelte';
	import PillDigitalIoSettings from './PillDigitalIOSettings.svelte';
	import PillAnalogSettings from './PillAnalogSettings.svelte';
	import PillLedStripSettings from './PillLEDStripSettings.svelte';

	export let device: Device = null;
	let expanded = [];

	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore || {};
	$: pillMode = settings?.pill?.mode || null;

	$: settingsMenu = [
		{
			name: 'pill_mode',
			component: PillPeripheralMode,
			title: $format('subsettings_title_pill_peripheral_mode', {
				default: 'Pill Peripheral Mode',
			}),
			props: {
				device,
				icon: 'fas fa-sensor-on',
			},
		},
		{
			name: 'analog_range',
			component: PillAnalogSettings,
			title: $format('settings_title_pill_analog', {
				default: 'Analog Measurement',
			}),
			props: {
				device,
				icon: 'fas fa-gauge-circle-bolt',
			},
			disabled: pillMode !== 'analog_in',
			hidden: pillMode !== 'analog_in',
		},
		{
			name: 'led_strip',
			component: PillLedStripSettings,
			title: $format('settings_title_pill_led_strip', {
				default: 'LED Strip',
			}),
			props: {
				device,
				icon: 'fal fa-lightbulb',
			},
			hidden: pillMode !== 'ledstrip',
		},
		{
			name: 'digital_io',
			component: PillDigitalIoSettings,
			title: $format('settings_title_pill_digital_io', {
				default: 'Digital IO Settings',
			}),
			props: {
				icon: 'fal fa-arrows-up-down',
			},
			type: 'collapse',
		},
	];
	$: menuItems = settingsMenu.filter((item) => !item.hidden);

	$: {
		if (!expanded.length && pillMode === 'digital_io') {
			let digIndex = settingsMenu.findIndex((item) => item.name === 'digital_io');
			expanded[digIndex] = true;
		}
	}

	const toggleExpanded = (index: number) => {
		expanded[index] = !expanded[index];
	};
</script>

{#each menuItems as { title, component, type, props }, i}
	{#if type === 'collapse'}
		<Collapse
			id="collapse-4z6whe9"
			title={capFirstChar(title)}
			class="mb-m mt-s"
			expanded={expanded[i]}
			on:click={() => {
				toggleExpanded(i);
			}}
		>
			<svelte:component this={component} {...props} {device} {settings} />
		</Collapse>
	{:else}
		<svelte:component this={component} class="mb-m mt-s" {...props} {device} {settings} />
	{/if}
{/each}
